import Vue from 'vue'
import VueRouter from 'vue-router'
import { loadLanguageAsync } from '@/libs/i18n-setup'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(() => {}) // sink error
}

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () =>
        process.env.VUE_APP_ENABLE_AUTH0 === 'true' ? import('@/views/authentication/Login.vue') : import('@/views/authentication/LoginDirect.vue'),
      meta: {
        layout: 'full'
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('@/views/authentication/Logout.vue'),
      meta: {
        layout: 'full'
      }
    },

    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/views/dashboard/Index.vue'),
      meta: {
        pageTitle: 'Dashboard',
        breadcrumb: [
          {
            text: 'Dashboard',
            active: true
          }
        ]
      }
    },
    {
      path: '/',
      redirect: 'organisations',
      component: () => import('@/views/home/Index.vue'),
      children: [
        {
          path: 'organisations',
          name: 'Organisations',
          component: () => import('@/views/organisations/Index'),
          meta: {
            pageTitle: 'Organisations',
            breadcrumb: [
              {
                text: 'Organisations',
                active: true
              }
            ]
          }
        },
        {
          path: '/organisations/:organisationId',
          name: 'Organisation Details',
          component: () => import('@/views/organisation/Index'),
          meta: {
            pageTitle: 'Organisation Details',
            breadcrumb: [
              {
                text: 'Organisation Details',
                active: true
              }
            ]
          }
        },
        {
          path: '/organisations/:organisationId/group/:groupId',
          name: 'Group Details',
          component: () => import('@/views/group/Index'),
          meta: {
            pageTitle: 'Group Details',
            breadcrumb: [
              {
                text: 'Organistaion'
              },
              {
                text: 'Group Details',
                active: true
              }
            ]
          }
        },
        {
          path: '/organisations/:organisationId/group/:groupId/user/:userId',
          name: 'User Details',
          component: () => import('@/views/user/index'),
          meta: {
            pageTitle: 'User Details',
            breadcrumb: [
              {
                text: 'Organistaion'
              },
              // {
              //   text: 'Group Details'
              // },
              {
                text: 'User Details',
                active: true
              }
            ]
          }
        }
      ]
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full'
      }
    },
    {
      path: '*',
      redirect: 'error-404'
    }
  ]
})
router.beforeEach((to, from, next) => {
  const lang = localStorage.getItem('locale') || 'en'
  loadLanguageAsync(lang)
    .then(() => next())
    .catch((err) => {
      console.log(`Failed to load language: ${err}`)
      next()
    })
})
export default router
